import { ProdlogService } from '@gtpl/shared-services/production';
import { Button, Card, Col, Descriptions, Form, Input, message, Modal, Row, Select, Table, Tabs } from 'antd'
import { ColumnProps } from 'antd/lib/table';
import React, { useEffect, useRef, useState } from 'react'
import { Link, useHistory } from "react-router-dom";
import { ArrowRightOutlined, EyeOutlined } from '@ant-design/icons';
import { DeheadingReportingTypeEnum } from '@gtpl/shared-models/common-models';
import { ProductService } from 'libs/shared-services/masters/src/lib/products-service';
import { DegummingOutputLogReq, DegummingReq } from '@gtpl/shared-models/production-management';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, FilePdfOutlined, DownloadOutlined } from '@ant-design/icons';

const DegummingGrid = () => {
  const [page, setPage] = React.useState(1);
  const [degummingInputData, setDegummingInputData] = useState<any[]>([]);
  const productionLogService = new ProdlogService();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [form] = Form.useForm();
  const { Option } = Select;
  const [variants, setVariants] = useState<any[]>([])
  const variantService = new ProductService()
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [workOrderNo, setWorkOrderNo] = useState<any[]>([])
  const [quality, setQuality] = useState<any[]>([])
  const [variantData, setVariantData] = useState<any[]>([])
  const [filterForm] = Form.useForm();
  const { TabPane } = Tabs;
  const [tabName, setTabName] = useState<string>('Open')
  const [closedData, setClosedData] = useState<any[]>([])
  const history = useHistory();
  const [outProducts, setOutProducts] = useState<any[]>([])
  const plantId = Number(localStorage.getItem("unit_id"));
  const createdUser = JSON.parse(localStorage.getItem('username'));

  useEffect(() => {
    if (tabName == 'Open') {
      getDegummingQtyForDegumming();
    } else {
      getClosedDegummingData();
    }
  }, [tabName]);


  useEffect(() => {
    // getDegummingQtyForDegumming();
    getVariants()
    getOpenLWorkOrdersForDegumming()
    getOpenVariantForDegumming()
    getQualityVariantForDegumming()
    getDegummingOutProducts()
  }, []);

  const getOpenLWorkOrdersForDegumming = () => {
    productionLogService.getOpenLWorkOrdersForDegumming().then(res => {
      if (res.status) {
        setWorkOrderNo(res.data)
      } else {
        setWorkOrderNo([])
      }
    })
  }

  const getOpenVariantForDegumming = () => {
    productionLogService.getOpenVariantForDegumming().then(res => {
      if (res.status) {
        setVariantData(res.data)
      } else {
        setVariantData([])
      }
    })
  }

  const getQualityVariantForDegumming = () => {
    productionLogService.getQualityVariantForDegumming().then(res => {
      if (res.status) {
        setQuality(res.data)
      } else {
        setQuality([])
      }
    })
  }

  const getDegummingOutProducts = () => {
    productionLogService.getDegummingOutProducts().then(res => {
      if (res.status) {
        setOutProducts(res.data)
      } else {
        setOutProducts([])
      }
    })
  }

  const getVariants = () => {
    variantService.getAllActiveProducts().then(res => {
      if (res.status) {
        setVariants(res.data)
      } else {
        setVariants([])
      }
    })
  }

  const getDegummingQtyForDegumming = () => {
    const req = new DegummingReq();
    if (filterForm.getFieldValue('filterWorkOrder') != undefined) {
      req.workOrderNo = filterForm.getFieldValue('filterWorkOrder')
    }
    if (filterForm.getFieldValue('filterVariant') != undefined) {
      req.variantId = filterForm.getFieldValue('filterVariant')
    }
    productionLogService.getDegummingQtyForDegumming(req).then(res => {
      if (res.status) {
        setDegummingInputData(res.data);
      } else {
        setDegummingInputData([]);
      }
    })
  }

  const getClosedDegummingData = () => {
    const req = new DegummingReq();
    if (filterForm.getFieldValue('filterWorkOrder') != undefined) {
      req.workOrderNo = filterForm.getFieldValue('filterWorkOrder')
    }
    if (filterForm.getFieldValue('filterVariant') != undefined) {
      req.variantId = filterForm.getFieldValue('filterVariant')
    }
    if (filterForm.getFieldValue('filterOutVariant') != undefined) {
      req.outVariantId = filterForm.getFieldValue('filterOutVariant')
    }
    productionLogService.getClosedDegummingData(req).then(res => {
      if (res.status) {
        const formatted = transformClosedData(res.data);
        setClosedData(formatted);
      } else {
        setClosedData([]);
      }
    })
  }

  const transformClosedData = (data: any[]) => {
    const grouped: any = {};

    data.forEach(item => {
      const key = `${item.workOrderNo}_${item.product}_${item.quality}`;

      if (!grouped[key]) {
        grouped[key] = {
          ...item,
          outputs: [],
          totalOutput: 0
        };
      }

      grouped[key].outputs.push(item);
      grouped[key].totalOutput += Number(item.outputQty || 0);
    });

    return Object.values(grouped);
  };

  const openModal = (record) => {
    setSelectedRow(record);
    setIsModalOpen(true);
    form.resetFields();
  };

  const handleSubmit = async (values) => {
    console.log(values, "valuessssssssss")
    try {
      const selectedVariant = variants.find(v => v.productId === selectedRow.variantId);
      const outputQty = Number(values.outputQuantity);
      const inputQty = Number(selectedRow?.degummedQty || 0);
      const availableQty =
  Number(selectedRow?.degummedQty || 0) -
  Number(selectedRow?.degummedOutputQty || 0);

      if (!outputQty || outputQty <= 0) {
        message.error('Output quantity must be greater than 0');
        return;
      }

      if (availableQty <= 0) {
  message.error('No available quantity left for reporting');
  return;
}

      if (outputQty > availableQty) {
        message.error(`Output quantity cannot exceed available quantity (${availableQty.toFixed(2)})`);
        return;
      }

      let reportingType = values.reportingType;

// If user reports entire available qty but selected Partial
if (
  outputQty === availableQty &&
  values.reportingType?.toLowerCase() === 'partial'
) {
  reportingType = 'Full';

  message.warning(
    'Complete available quantity has been reported. Reporting Type has been automatically changed from Partial to Full.'
  );
}

const req = new DegummingOutputLogReq(
  selectedRow.workOrderNo,
  new Date(),
  plantId,
  Number(values.outputQuantity),
  selectedRow.prodInvId,
  values.remarks || null,
  selectedRow.quality,
  values.outputVariant,
  selectedVariant?.productName,
  reportingType, // use updated value
  selectedRow.productionLogId,
  createdUser
);

      // const req = new DegummingOutputLogReq(
      //   selectedRow.workOrderNo,
      //   new Date(),
      //   plantId,
      //   Number(values.outputQuantity),
      //   selectedRow.prodInvId,
      //   values.remarks || null,
      //   selectedRow.quality,
      //   values.outputVariant,
      //   selectedVariant?.productName,
      //   values.reportingType,
      //   selectedRow.productionLogId,
      //   createdUser
      // );

      const res = await productionLogService.createLogForOutputDegumming(req);

      if (res.status) {
        message.success(res.internalMessage || 'Degumming O/P Captured successfully');
        setIsModalOpen(false);
        form.resetFields();
        setIsModalOpen(false);
        getDegummingQtyForDegumming();

      } else {
        message.error(res.internalMessage || 'Failed to capture Degumming O/P');
        console.log("❌ Failed:", res.internalMessage);
      }

    } catch (err) {
      console.error("🔥 Error:", err);
    }
  };

  const handleResetModal = () => {
    form.resetFields();
  };

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      ) : null
  });

  const Columns: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      align: 'left',
      responsive: ['md'],
      render: (text, row, index) => {
        const value = (page - 1) * 10 + (index + 1);
        return {
          children: value,
          props: { rowSpan: tabName === 'Closed' ? row.rowSpan : 1 }
        };
      }
    },
    ...(tabName === 'Open'
      ? [
        {
          title: 'Date',
          dataIndex: 'date',
          sorter: (a, b) =>
            new Date(a.date || 0).getTime() - new Date(b.date || 0).getTime(),
          sortDirections: ['descend' as const, 'ascend' as const],
          render: (text) =>
            text ? new Date(text).toLocaleDateString('en-GB') : '-',
        },
      ]
      : []),

    {
      title: 'Work Order No',
      dataIndex: 'workOrderNo',
      sorter: (a, b) => (a.workOrderNo || '').localeCompare(b.workOrderNo || ''),
      ...getColumnSearchProps('workOrderNo'),
      render: (text, row) => {
        if (tabName !== 'Closed') return text; // ✅ IMPORTANT

        return {
          children: text,
          props: { rowSpan: row.rowSpan }
        };
      }
    },
    {
      title: 'Input Variant',
      dataIndex: 'product',
      sorter: (a, b) => (a.product || '').localeCompare(b.product || ''),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('product'),
      render: (text, row) => ({
        children: text,
        props: { rowSpan: tabName === 'Closed' ? row.rowSpan : 1 }
      })
    },
    ...(tabName == 'Closed' ? [
      {
        title: 'Output Variant',
        dataIndex: 'outProduct',
        //   sorter: (a, b) => a.outProduct?.localeCompare(b.outProduct),
        //  sortDirections: ['descend' as const, 'ascend' as const],
        // ...getColumnSearchProps('outProduct'),

      }] : []),
    {
      title: 'Quality',
      dataIndex: 'quality',
      sorter: (a, b) => (a.quality || '').localeCompare(b.quality || ''),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('quality'),
      render: (text, row) => ({
        children: text,
        props: { rowSpan: tabName === 'Closed' ? row.rowSpan : 1 }
      })
    },
    {
      title: "WO Quantity",
      dataIndex: 'woQty',
      render: (text, row) => ({
        children: text != null ? Number(Number(text).toFixed(2)) : '',
        props: { rowSpan: tabName === 'Closed' ? row.rowSpan : 1 }
      })
    },
    {
      title: "Input quantity",
      dataIndex: 'degummedQty',
      render: (text, row) => ({
       children: text != null ? Number(Number(text).toFixed(2)) : '',
        props: { rowSpan: tabName === 'Closed' ? row.rowSpan : 1 },

      })
    },
    ...(tabName == 'Closed' ? [
      {
        title: "Degummed O/P quantity",
        dataIndex: 'outputQty',
        render: (value) => Number(Number(value).toFixed(2))
      }] : []),

    ...(tabName == 'Closed' ? [
      {
        title: "Yield %",
        render: (_, record) => {
          const input = Number(record.degummedQty || 0);
          const output = Number(record.outputQty || 0);

          if (input > 0) {
            const yieldPercent = (output / input) * 100;
            return `${yieldPercent.toFixed(2)} %`;
          }

          return '0 %';
        }
      }] : []),
    ...(tabName == 'Closed' ? [
      {
        title: "Total Yield %",
        render: (_, row) => ({
          children: row.rowSpan > 0 ? `${row.totalYield} %` : null,
          props: { rowSpan: row.rowSpan }
        })
      }
    ] : []),

    ...(tabName == 'Open' ? [
      {
        title: 'Action',
        render: (_, record) => (
          <ArrowRightOutlined
            style={{ fontSize: '18px', cursor: 'pointer', color: '#1890ff' }}
            onClick={() => openModal(record)}
          />
        )
      }
    ] : []),

    //          ...(tabName == 'Closed' ? [
    //      {
    //   title: 'Action',
    //   render: (_, record) => (
    //     <EyeOutlined
    //       style={{ fontSize: '18px', cursor: 'pointer', color: '#1890ff' }}
    //       onClick={() => {
    //         history.push('/degumming-detailed-view', { record });
    //       }}
    //     />
    //   )
    // }
    // ] : []),
  ]

  const handleFilterSubmit = (values) => {
    if (tabName == 'Open') {
      getDegummingQtyForDegumming();
    } else {
      getClosedDegummingData();
    }
  }

  const handleResetFilter = () => {
    filterForm.resetFields();
    if (tabName == 'Open') {
      getDegummingQtyForDegumming();
    } else {
      getClosedDegummingData();
    }
  }

  const onTabChange = (val) => {
    setTabName(val);
    setPage(1);
    filterForm.resetFields();
  }

  const getClosedTableData = () => {
    const finalData: any[] = [];
    closedData.forEach((group: any) => {
      group.outputs.forEach((row, i) => {
        finalData.push({
          ...row,
          rowSpan: i === 0 ? group.outputs.length : 0,
          totalYield: ((group.totalOutput / group.degummedQty) * 100).toFixed(2)
        });
      });
    });
    return finalData;
  };
  return (
    <div>
      <Card title={<span style={{ color: 'white' }}>Degumming</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} extra={
        <span style={{ color: 'white' }}>
          <Button><Link to="/degumming-form">Create</Link></Button>
        </span>
      }>

        <Form
          form={filterForm}
          layout="vertical"
          onFinish={handleFilterSubmit}
          style={{ marginTop: 20 }}
        >
          <Row gutter={12}>
            <Col span={6}>
              <Form.Item label={'Work Order'} name='filterWorkOrder' >
                <Select allowClear showSearch optionFilterProp='children' placeholder='Select  Work Order'>
                  {
                    workOrderNo.map(e => {
                      return (
                        <Option key={e.workOrderNo} value={e.workOrderNo}>{e.workOrderNo}</Option>
                      )
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label={'Variant'} name='filterVariant' >
                <Select allowClear showSearch optionFilterProp='children' placeholder='Select  Variant'>
                  {
                    variantData.map(e => {
                      return (
                        <Option key={e.variantId} value={e.variantId}>{e.variantName}</Option>
                      )
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            {
              tabName == 'Open' ? (<></>) : (<>
                <Col span={6}>
                  <Form.Item label={'Out Variant'} name='filterOutVariant' >
                    <Select allowClear showSearch optionFilterProp='children' placeholder='Select  Variant'>
                      {
                        outProducts.map(e => {
                          return (
                            <Option key={e.productId} value={e.productId}>{e.variantName}</Option>
                          )
                        })
                      }
                    </Select>
                  </Form.Item>
                </Col>
              </>)}
            <Col>
              {/* 🔹 Buttons */}
              <Form.Item style={{ textAlign: 'center' }}>
                <Button type="primary" htmlType="submit" style={{ marginRight: 10, marginTop: 30 }}>
                  Submit
                </Button>
                <Button danger onClick={handleResetFilter} style={{ marginTop: 30 }}>
                  Reset
                </Button>
              </Form.Item>
            </Col>
          </Row>

        </Form>
        <Tabs onChange={onTabChange}>
          <TabPane key='Open' tab='OPEN'>
            <Table columns={Columns} dataSource={degummingInputData} pagination={{
              current: page,
              onChange: (p) => setPage(p)
            }} />
          </TabPane>
          <TabPane key='Closed' tab='COMPLETED'>
            <Table
              columns={Columns}
              dataSource={getClosedTableData()}
              pagination={{
                current: page,
                onChange: (p) => setPage(p)
              }}
            />
          </TabPane>
        </Tabs>

        <Modal
          title="Degumming Output Details"
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
           width={900}
          footer={null}
          
        >
          {selectedRow && (
            <Descriptions bordered size="small" column={2}>
              <Descriptions.Item label="Work Order">{selectedRow.workOrderNo}</Descriptions.Item>
              <Descriptions.Item label="Quality">{selectedRow.quality}</Descriptions.Item>
              <Descriptions.Item label="WO Qty">{Number(Number(selectedRow.woQty || 0).toFixed(2))}</Descriptions.Item>
              <Descriptions.Item label="Input Qty">{Number(Number(selectedRow.degummedQty || 0).toFixed(2))}</Descriptions.Item>
              <Descriptions.Item label="Degummed O/P Qty">{Number(Number(selectedRow.degummedOutputQty || 0).toFixed(2))}</Descriptions.Item>
              <Descriptions.Item label="Available Qty">{Number(Number((selectedRow.degummedQty || 0) - (selectedRow.degummedOutputQty || 0)).toFixed(2))}</Descriptions.Item>
            </Descriptions>
          )}

          {/* 🔹 Form */}
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            onValuesChange={(changedValues) => {
              if (changedValues.outputQuantity !== undefined) {
                const inputQty = selectedRow?.degummedQty || 0;
                const outputQty = Number(changedValues.outputQuantity);

                if (inputQty > 0 && outputQty >= 0) {
                  const yieldValue = outputQty / inputQty;
                  const yieldPercent = yieldValue * 100;

                  form.setFieldsValue({
                    yield: yieldValue.toFixed(4),
                    yieldPercent: yieldPercent.toFixed(2)
                  });
                } else {
                  form.setFieldsValue({
                    yield: 0,
                    yieldPercent: 0
                  });
                }
              }
            }}
            style={{ marginTop: 20 }}
          >
            <Row gutter={12}>
              <Col span={6}>
                <Form.Item
                  label="Output Quantity"
                  name="outputQuantity"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label={'Output Variant'} name='outputVariant' rules={[{ required: true, message: 'Output Variant is required' }]}>
                  {/* <Input placeholder='Enter Variant'/> */}
                  <Select allowClear showSearch optionFilterProp='children' placeholder='Select Output Variant'>
                    {
                      variants.map(e => {
                        return (
                          <Option key={e.productId} value={e.productId}>{e.productName}</Option>
                        )
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Reporting Type"
                  name="reportingType"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="Select Reporting Type">
                    {Object.values(DeheadingReportingTypeEnum).map(val => (
                      <Option key={val} value={val}>
                        {val}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Yield %" name="yieldPercent">
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row>

              <Col>
                {/* 🔹 Buttons */}
                <Form.Item style={{ textAlign: 'center', marginTop: 30 }}>
                  <Button type="primary" htmlType="submit" style={{ marginRight: 10, marginTop: 30 }}>
                    Submit
                  </Button>
                  <Button danger onClick={handleResetModal} style={{ marginTop: 30 }}>
                    Reset
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Card>
    </div>
  )
}

export default DegummingGrid